import React, { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import './Document.css';
import { fetchBomReferenceSupplier } from '../../Library/BomLibrary/store/BomLibrary.action';
import CustomDatePicker from '../../../Components/Utility/DatePicker/DatePicker';
import { SystemMasterSelect } from '../../../Components/helper';

const initialState = {
  status: '',
  supplier: null,
  selectedDate: null,
  comment: '',
};

const forModalBtns = (hideSupplier) => {
  return hideSupplier ? 'status1_0' : 'status1_1';
};

const forOrignalBtns = (hideSupplier) => {
  return hideSupplier ? 'status_0' : 'status_1';
};

const fromDevId = (fromModal, status_0, hideSupplier) => {
  return fromModal ? status_0 : forOrignalBtns(hideSupplier);
};

const disablingCondition = (fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable) => {
  return (
    (!fromBomExpand && !fromProductTesting && !fromTestingLib && !fromProductCareLabel && !fromSampleMissingComponent && isDisable) ||
    ((fromTestingLib || fromProductTesting || fromProductCareLabel || fromBomExpand || fromSampleMissingComponent) && btnsDisable)
  );
};

function DocumentApproveRejectFooter({
  selectedIdArray,
  selectedIdsArray,
  devOrderId,
  selectedTab,
  hideSupplier,
  onSave,
  selectedDocType,
  disabledSaveBtn,
  userInfo,
  selectedRefCode,
  selectedDocStatus,
  fromBomExpand,
  btnsDisable,
  fromProductTesting,
  fromProductCareLabel,
  fromTestingLib,
  status_0,
  status_1,
  fromModal,
  fromBomList,
  fromSampleMissingComponent,
  careBtnsDisable,
  isDisabledState,
  fromSupplierDocumentComponent,
}) {
  const { t } = useTranslation('common');

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [selectedDate, setDate] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [hasError, setHasError] = useState(false);
  const [commentCount, setCommentCount] = useState(0);
  const [commentError, setCommentError] = useState(false);

  const [comment, setComment] = useState(null);
  useEffect(() => {
    if (isDisable) {
      setValue('supplier', '', {
        shouldValidate: false,
      });
      setValue('status', 0, {
        shouldValidate: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisable]);

  const handleDropdownChange = (value) => {
    setValue('status', value, { shouldValidate: true });
    setSelectedStatus(value);
  };

  const handleDateChange = (date) => {
    setDate(date);
  };

  const handleCommentData = (data) => {
    setComment(data);
    const inputLength = data.length;
    setCommentCount(inputLength);
  };

  const onSubmitMethod = async (data) => {
    if (!selectedDate || !comment) {
      if (!selectedDate) {
        setHasError(true);
      } else {
        setCommentError(true);
      }
    } else {
      const obj = {
        ...data,
        commentDate: selectedDate || data.selectedDate,
        approveBy: userInfo.userId,
      };

      if (!fromProductTesting && !fromProductCareLabel && !fromTestingLib && (fromBomExpand || fromBomList)) {
        obj.refCodes = selectedRefCode;
        obj.bomLibIds = selectedIdArray;
        obj.bomIds = selectedIdsArray;
        obj.supplierId = data?.supplier?._id || '';
      }
      delete obj.supplier;
      delete obj.selectedDate;
      const value = obj;
      const id = selectedTab?._id || '';
      if (fromProductTesting || fromTestingLib || fromSampleMissingComponent) {
        onSave(devOrderId, value);
        setValue('result', '');
      } else {
        onSave(id, devOrderId, value);
      }
      for (const [key, val] of Object.entries(initialState)) {
        if (key === 'selectedDate') {
          setDate(val);
          setHasError(false);
        }
        if (key === 'status') {
          setSelectedStatus(val);
        }

        if (key === 'comment') {
          setComment(val);
          setCommentError(false);
        }
        setValue(key, val);
        !fromBomExpand && setIsDisable(disabledSaveBtn);
        setCommentCount(0);
      }
    }
  };
  const isDocumentSelected = selectedDocType.includes('Document');
  const isTemplateSelected = selectedDocType.includes('Template');
  const activeSelectedDocStatus = selectedDocStatus.filter((item) => item.isActive).map((item) => item);

  return (
    <div className="common-approve-reject-footer status-footer">
      <div className="radio-date-container radio-approve">
        {isDocumentSelected && !isTemplateSelected && (
          <div className="mb-0 w-200px mr-16 common-react-select">
            <Select
              name="status"
              {...register('status', {
                required: true,
              })}
              isClearable
              menuPlacement="top"
              options={activeSelectedDocStatus || []}
              getOptionLabel={({ name }) => `${name}`}
              getOptionValue={({ name }) => `${name}`}
              value={selectedStatus}
              onChange={handleDropdownChange}
              styles={SystemMasterSelect}
              placeholder={t('SUPLIER.ADD_EDIT_SUPPLIER_OVERVIEW.SELECT_STATUS')}
              disabled={isDisabledState || selectedIdArray.length === 0}
              className={`${errors.status ? 'required-field' : ''} common-select`}
              classNamePrefix="common-select"
            />
          </div>
        )}
        {isTemplateSelected && !isDocumentSelected && (
          <div className="approve-reject">
            <div className="d-flex align-items-center">
              <p className="custom-radio mb-0 mr-3">
                <input
                  type="radio"
                  id={fromDevId(fromModal, status_0, hideSupplier)}
                  name="status"
                  value={1}
                  {...register('status', { required: true })}
                  disabled={isDisabledState || isDisable || btnsDisable}
                />
                <label className="m-0" htmlFor={fromDevId(fromModal, status_0, hideSupplier)}>
                  {t('APPROVE_REJECT_FOOTER.APPROVED')}
                </label>
              </p>
              <p className="custom-radio mb-0 mr-3">
                <input
                  type="radio"
                  id={fromModal ? status_1 : forModalBtns(hideSupplier)}
                  name="status"
                  value={0}
                  {...register('status', { required: true })}
                  disabled={isDisabledState || isDisable || btnsDisable}
                />
                <label className="m-0" htmlFor={fromModal ? status_1 : forModalBtns(hideSupplier)}>
                  {t('APPROVE_REJECT_FOOTER.REJECTED')}
                </label>
              </p>
              {errors.status && <span className="error-message xs-position-bottom">{t('APPROVE_REJECT_FOOTER.STATUS_REQUIRED')}</span>}
            </div>
          </div>
        )}

        <div className="date">
          <div className={`${hasError && !selectedDate ? 'required-field' : ''} input-button-container`}>
            <CustomDatePicker
              valueProp={selectedDate}
              dateFormat="dd-MMM-yyyy"
              popperPlace="top-end"
              name="selectedDate"
              onChange={(date) => handleDateChange(date)}
              disable={
                isDisabledState ||
                disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable)
              }
            />
          </div>
        </div>
      </div>
      <div className="note-btn-container">
        <div className={`${commentError && !comment ? 'required-field' : ''} note`}>
          <input
            type="text"
            name="comment"
            className="form-control pr-40"
            placeholder={fromSupplierDocumentComponent ? t('APPROVE_REJECT_FOOTER.STATUS_COMMENTS') : t('APPROVE_REJECT_FOOTER.COMMENT_PLACEHOLDER')}
            {...register('comment', {
              required: false,
            })}
            maxLength="80"
            value={comment}
            onChange={(e) => handleCommentData(e.target.value)}
            disabled={
              isDisabledState ||
              disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable)
            }
          />
          <span className="char-count">{commentCount}/80</span>
        </div>
      </div>
      <div className="button-container">
        <button
          className="btn p-0"
          onClick={handleSubmit(onSubmitMethod)}
          type="button"
          disabled={
            disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable, btnsDisable) ||
            careBtnsDisable ||
            isDisabledState
          }
          aria-label="Save"
        >
          <i className="f-28 icon-Save-1 text-grey" />
        </button>
        <button
          className="btn btn-default bg-white ml-2 d-md-none"
          onClick={handleSubmit(onSubmitMethod)}
          type="button"
          aria-label="Save"
          disabled={
            isDisabledState ||
            disablingCondition(fromBomExpand, fromProductTesting, fromProductCareLabel, fromTestingLib, fromSampleMissingComponent, isDisable)
          }
        >
          <span className="icon-Save" />
        </button>
      </div>
    </div>
  );
}

const mapStateToProps = ({ BomLibraryDetails, UserDetails, BOMConfigDetails }) => {
  const { userInfo } = UserDetails;
  const { ReferenceSupplier } = BomLibraryDetails;
  const { cardList } = BOMConfigDetails;
  return {
    ReferenceSupplier,
    userInfo,
    cardList,
  };
};

const mapStateToDispatch = {
  fetchBomReferenceSupplier,
};

export default connect(mapStateToProps, mapStateToDispatch)(DocumentApproveRejectFooter);
